<!-- Page Header Start-->
<div class="page-header row" [ngClass]="{'close_icon' :navService.collapseSidebar }">
  <div class="col-auto header-left-wrapper">
    <div class="header-logo-wrapper p-0 left-header">
      <div class="logo-wrapper">
        <a [routerLink]="['/pages/first-page']">
          <img class="img-fluid" src="assets/images/logo/logo_dark.png" alt></a>
      </div>
    </div>
    <div class="toggle-sidebar" (click)="closeMenu()">
      <app-common-svg-icons [class]="'status_toggle sidebar-toggle'"
        [icons]="'collapse-sidebar'"></app-common-svg-icons>
    </div>
  </div>
  <div class="col-auto header-right-wrapper page-title">
    <app-breadcrumb></app-breadcrumb>
  </div>
  <div class="col header-wrapper m-0 header-right-wrapper" [class.open]="isOpen">
    <div class="row m-0">
      <app-search [data]="isOpen" (newItemEvent)="closeSearch($event)"></app-search>
      <div class="header-logo-wrapper col-auto p-0 left-header"></div>
      <div class="nav-right col-auto pull-right right-header p-0 ms-auto">
        <ul class="nav-menus">
          <li class="onhover-dropdown">
            <app-notifications></app-notifications>
          </li>
          <li>
            <app-mode></app-mode>
          </li>
          <li class="profile-nav onhover-dropdown">
            <app-profile></app-profile>
          </li>
        </ul>
      </div>
      <script class="result-template" type="text/x-handlebars-template">
        <div class="ProfileCard u-cf">                        
        <div class="ProfileCard-avatar"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-airplay m-0"><path d="M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1"></path><polygon points="12 15 17 21 7 21 12 15"></polygon></svg></div>
        <div class="ProfileCard-details">
        <div class="ProfileCard-realName">{{name}}</div>
        </div>
        </div>
      </script>
      <script class="empty-template"
        type="text/x-handlebars-template"><div class="EmptyMessage">Your search turned up 0 results. This most likely means the backend is down, yikes!</div></script>
    </div>
  </div>
</div>
